<template>
  <ModuleSection title="提款记录">

    <!-- cbtj新详情 -->
    <template v-if="newType == 'hftx'">
      <!-- 交易信息 -->
      <div class="title-container">

        <el-row>

          <div class="sub-title">
            {{$t('基础信息')}}
          </div>

          <el-form
            class="form"
            label-width="180px"
            label-position="left"
          >
            <el-col
              :span="12"
              v-for="item in baseInfoColumn"
              :key="item.label"
              :class="{'en': $store.state.app.lang === 'en'}"
            >
              <el-form-item :label="$t(item.label)+'：'">
                {{ $t(newData.settlementOrderQueryResponse[item.prop]) || "--" }}
              </el-form-item>
            </el-col>
          </el-form>

        </el-row>
      </div>
      <div class="title-container">
        <el-row>

          <div class="sub-title">
            {{$t('补充文件')}}
          </div>
          <div
            class="file-container"
            v-if="newData.settlementOrderQueryResponse.otherFiles.length"
          >
            <div class="label">
              {{$t('其他文件')}}：
            </div>
            <div class="value">
              <div
                class="wrapper"
                v-for="(item,index) in newData.settlementOrderQueryResponse.otherFiles"
                :key="index"
              >
                <el-link
                  type="primary"
                  class="btn"
                  size="large"
                  @click="handleView(item)"
                >
                  {{$t('查看')}}
                </el-link>
                {{$t(item.fileName)}}

              </div>
            </div>

          </div>
        </el-row>
      </div>
      <!-- 销售订单 -->
      <el-row>
        <div class="sub-title">
          {{$t('销售订单')}}
        </div>
        <el-table
          ref="purchaseOrderDetailResponseListTable"
          :data="newData.purchaseOrderDetailResponseList"
          style="width: 100%;margin-bottom:22px;"
        >
          <el-table-column
            prop="purchaseOrderNo"
            :label="$t('订单号')"
            align="center"
          />
          <el-table-column
            prop="payLocal"
            :label="$t('订单金额')"
            align="center"
          />
          <el-table-column
            prop="orderDate"
            :label="$t('订单时间')"
            align="center"
          />
          <el-table-column
            :label="$t('操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                @click="handleViewDetails(scope.row)"
                type="text"
              >
                {{$t('详情')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="sub-title">
          {{$t('汇入单')}}：
        </div>
        <el-table
          ref="affluxOrderInfoRequestListTable"
          :data="newData.affluxOrderInfoRequestList"
          style="width: 100%;margin-bottom:22px;"
        >
          <el-table-column
            v-for="(item, index) in transferColumnList"
            :key="index"
            :label="$t(item.label)"
            :prop="item.prop"
            :width="item.width || '185px'"
            :align="item.align || 'left'"
          >
            <template slot-scope="scope">
              {{ $t(scope.row[item.prop]) }}
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </template>
    <!-- 老详情 -->
    <template v-else>
      <!-- 交易信息 -->
      <el-row>
        <div class="sub-title">
          {{$t('交易信息')}}
        </div>

        <el-form
          class="form"
          label-width="auto"
          label-position="right"
        >
          <el-col
            :span="12"
            v-for="item in oldBaseInfoColumn"
            :key="item.label"
          >
            <el-form-item :label="$t(item.label)+'：'">
              {{ data[item.prop] || "--" }}
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <!-- 报备信息 -->
      <el-row>

        <div class="sub-title">
          {{$t('报备信息')}}
        </div>

        <el-form
          class="form"
          label-width="auto"
          label-position="right"
        >
          <el-col :span="12">
            <el-form-item :label="$t('申请提款时间')+'：'">
              {{ data.settleOrderReport.createTime || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('销售订单号码')+'：'">
              {{ data.settleOrderReport.sellOrderNo || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('订单日期')+'：'">
              {{ data.settleOrderReport.sellOrderTime || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('销售商品名称')+'：'">
              {{ data.settleOrderReport.goodsNames || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('销售数量')+'：'">
              {{ data.settleOrderReport.goodsCount || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('商品/店铺网址')+'：'">
              {{ data.settleOrderReport.storeUrl || "--" }}
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row>
        <el-form>

          <el-col :span="24">
            <div class="sub-title">
              {{$t('汇入单')}}
            </div>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="data.settleOrderReport.transferInList"
              style="width: 100%;margin-bottom:22px;"
            >
              <el-table-column
                v-for="(item, index) in transferColumnList"
                :key="index"
                :label="$t(item.label)"
                :prop="item.prop"
                :width="item.width || '180px'"
                :align="item.align || 'left'"
              >
                <template slot-scope="scope">
                  {{ $t(scope.row[item.prop]) }}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-form>
      </el-row>
      <el-row>
        <el-form>
          <el-col :span="24">
            <el-form-item
              :label="$t('交易物流单据')"
              prop="logisticsFiles"
            >
              <UploadFile
                :file-list="logisticsFiles"
                :disabled="true"
              >
              </UploadFile>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row>
        <el-form>
          <el-col :span="24">
            <el-form-item
              :label="$t('其他补充资料')"
              prop="replenishFiles"
            >
              <div style="display: flex;">

                <UploadFile
                  :file-list="replenishFiles"
                  :disabled="true"
                >
                </UploadFile>
              </div>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </template>
    <!-- 退汇信息 -->
    <el-row>
      <div class="sub-title">
        {{$t('退汇信息')}}
      </div>
      <el-table
        :data="newType == 'hftx' ? newData.seRefundOrder : data.seRefundOrder"
        style="width: 100%;margin-bottom:22px;"
      >
        <el-table-column
          prop="tradeNoJd"
          :label="$t('退汇单号')"
          align="center"
        />
        <el-table-column
          prop="reexchangeTypeName"
          :label="$t('退汇类型')"
          align="center"
        />
        <el-table-column
          prop="reexchangeDate"
          :label="$t('退汇发起时间')"
          align="center"
        />
        <el-table-column
          prop="reexchangeAmount"
          :label="$t('退汇金额')"
          align="center"
        />
        <el-table-column
          prop="reexchangeFee"
          :label="$t('退汇手续费')"
          align="center"
        />
      </el-table>
    </el-row>
    <div class="button-container">
      <el-button
        type="info"
        @click="$router.go(-1)"
      >{{$t('返回')}}</el-button>
    </div>
    <AddOrderDialog
      componentsType="details"
      :visible.sync="showAddOrderDialog"
      title="订单详情"
      :infoData="selectData"
      modifyType="details"
    />
  </ModuleSection>
</template>

<script>
import UploadFile from '@/components/upload/UploadFile'
import settleApi from '../api/settle'

import uploadApi from '@/api/upload'
import { openBlob } from '@/utils/utils'

import AddOrderDialog from '../launchSettle/components/AddOrderDialog'

export default {
  name: 'SettlementDetail_refresh',
  components: {
    UploadFile,
    AddOrderDialog
  },
  data () {
    return {
      mimes: [
        {
          mime: 'application/pdf',
          regExp: /\.pdf$/,
          openInBrowser: true
        },
        {
          mime: 'image/jpg',
          regExp: /\.jpg$/,
          openInBrowser: true
        },
        {
          mime: 'image/jpeg',
          regExp: /\.jpeg$/,
          openInBrowser: true
        },
        {
          mime: 'image/png',
          regExp: /\.png$/,
          openInBrowser: true
        },
        {
          mime: 'application/vnd.ms-excel',
          regExp: /\.xls$/
        },
        {
          mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          regExp: /\.xlsx$/
        }
      ],
      oldBaseInfoColumn: [
        { label: '提款账户', prop: 'enterpriseCustomerAccount' },
        { label: '提款到银行卡', prop: 'bankCard' },
        { label: '申请提款金额', prop: 'amount' },
        { label: '提款币种', prop: 'currencyId' },
        { label: '手续费', prop: 'transferCharge' },
        { label: '实际提款金额', prop: 'respForAmount' },
        { label: '预计到账人民币', prop: 'predictAmount' },
        { label: '参考汇率', prop: 'paritiesPlan' },
        { label: '提款状态', prop: 'statusDesc' },
        { label: '实际到账时间', prop: 'actualArrivalTime' },
        { label: '资料状态', prop: 'replenishFileStatusString' }
      ],
      baseInfoColumn: [
        { label: '提款账户', prop: 'enterpriseCustomerAccount' },
        { label: '提款币种', prop: 'currencyId' },
        { label: '申请提款金额', prop: 'amount' },
        { label: '手续费', prop: 'transferCharge' },
        { label: '实际提款金额', prop: 'respForAmount' },
        { label: '实际到账人民币', prop: 'cnyAmount' },
        { label: '收款银行卡', prop: 'bindCard' },
        { label: '收款银行', prop: 'recvBankName' },
        { label: '实际到账时间', prop: 'actualArrivalTime' },
        { label: '提款状态', prop: 'statusDesc' },
        { label: '实际汇率', prop: 'respResultRate' }
      ],
      transferColumnList: [
        { label: '交易流水号', prop: 'lsTransferNo' },
        { label: '汇款人名称', prop: 'customerName' },
        { label: '汇款人账号', prop: 'accNo' },
        { label: '汇款金额', prop: 'reportAmount' },
        { label: '实际入账金额', prop: 'receiveAmount' },
        { label: '交易时间', prop: 'reportTime' },
        { label: '与汇款人关系', prop: 'relationship' },
        { label: '汇款用途', prop: 'purpose' }
      ],
      disabledButton: false,
      data: {
        orderList: [],
        settleOrderReport: {
          logisticsFiles: [],
          replenishFiles: []
        }
      },
      newData: {
        affluxOrderInfoRequestList: [],
        purchaseOrderDetailResponseList: [],
        seRefundOrder: [],
        settlementOrderQueryResponse: {
          otherFiles: []
        }
      },
      logisticsFiles: [],
      replenishFiles: [],
      // 再提交信息
      id: '',
      showAddOrderDialog: false,
      selectData: {},
      // 是否为hftx
      newType: 'hftx'
    }
  },
  mounted () {
    this.getSettleDetail()
  },

  methods: {
    getSettleDetail () {
      const { id } = this.$route.query
      settleApi.orderDetails({
        id
      }).then(res => {
        if (res) {
          const seRefundOrder = []
          if (res.seRefundOrder) {
            seRefundOrder.push(res.seRefundOrder)
          }
          this.newData = {
            ...res,
            seRefundOrder
          }
          // this.data = res
          // this.data.orderList = res.orderList || []
          // if (!res.orderList.length) {
          //   this.newType = ''
          //   // this.data.settleRefundOrder = res.settleRefundOrder || []
          //   this.logisticsFiles = res.settleOrderReport.logisticsFiles || []
          //   this.replenishFiles = res.settleOrderReport.replenishFiles || []
          // } else {
          //   this.newType = 'hftx'
          //   this.newData = res
          //   // this.newData.settleRefundOrder = res.settleRefundOrder || []
          // }

          this.$nextTick(() => {
            this.$refs.purchaseOrderDetailResponseListTable.doLayout()
            this.$refs.affluxOrderInfoRequestListTable.doLayout()
          })
        }
      })
    },
    handleViewDetails (item) {
      this.showAddOrderDialog = true
      this.selectData = item
    },
    handleView (item) {
      const { filePath } = item

      let type = ''
      const target = this.mimes.filter(item => item.regExp.test(filePath.toLowerCase()))
      if (target && target.length) {
        // 如果有满足条件的mime的话
        type = target[0].mime
      } else {
        // 否则，先暂且按 application/pdf 处理
        type = 'application/pdf'
      }
      uploadApi.downloadFile({
        fileName: filePath
      }).then(res => {
        if (res) {
          openBlob(res, type)
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.en {
  height: 80px;
}
.title-container {
  border-bottom: 1px solid #e6e9f4;
  padding-bottom: 40px;
  margin-bottom: 40px;
}
.sub-title {
  position: relative;
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: 500;
  color: @blackLarge;
  line-height: 16px;
  &::before {
    content: '';
    position: absolute;
    border-left: 2px solid @blue;
    left: -15px;
    top: 50%;
    height: 100%;
    transform: translateY(-50%);
  }
  span {
    font-size: 14px;
    font-weight: 300;
    color: @blackLess;
    line-height: 14px;
  }
}
.file-container {
  display: flex;
  font-size: 14px;
  font-weight: 300;
  color: @blackMore;
  line-height: 14px;
  .label {
    min-width: 180px;
    margin-bottom: 20px;
  }
  .wrapper {
    & + .wrapper {
      margin-top: 30px;
    }
  }
  .btn {
    margin-right: 20px;
    font-size: 14px;
  }
}
.tip-text {
  color: #8a92a1;
  font-size: 14px;
  line-height: 20px;
}
.button-container {
  margin-top: 20px;
}
</style>
